var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolServiceSla01 = function SvgSolServiceSla01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_service_sla-01_svg2__a",
    x1: 5.69,
    x2: 142.92,
    y1: 178.23,
    y2: -6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__b",
    x1: -16.37,
    x2: 120.85,
    y1: 161.88,
    y2: -23.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__c",
    x1: -33.7,
    x2: 103.52,
    y1: 149.05,
    y2: -36.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__d",
    x1: -21.7,
    x2: 115.53,
    y1: 157.94,
    y2: -27.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__e",
    x1: 10.15,
    x2: 147.37,
    y1: 181.54,
    y2: -3.69
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__f",
    x1: 5.55,
    x2: 142.78,
    y1: 178.13,
    y2: -7.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__g",
    x1: -5.62,
    x2: 131.61,
    y1: 169.85,
    y2: -15.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__h",
    x1: 26.23,
    x2: 163.45,
    y1: 193.45,
    y2: 8.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__i",
    x1: 21.63,
    x2: 158.85,
    y1: 190.04,
    y2: 4.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__j",
    x1: 10.27,
    x2: 147.49,
    y1: 181.62,
    y2: -3.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__k",
    x1: 37.52,
    x2: 174.74,
    y1: 201.81,
    y2: 16.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__l",
    x1: 26.15,
    x2: 163.37,
    y1: 193.39,
    y2: 8.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__m",
    x1: 53.4,
    x2: 190.62,
    y1: 213.58,
    y2: 28.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__n",
    x1: 24.76,
    x2: 161.99,
    y1: 192.36,
    y2: 7.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_sla-01_svg2__a",
    id: "sol_service_sla-01_svg2__o",
    x1: 86.48,
    x2: 223.7,
    y1: 238.08,
    y2: 52.86
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m101.76 45.89 1.64-4.31h11.18l1.62 4.3a2.91 2.91 0 0 0 2.73 1.88 2.924 2.924 0 0 0 2.73-3.94l-9.41-24.93a3.47 3.47 0 0 0-3.22-2.16c-1.42 0-2.68.85-3.25 2.23l-9.46 24.85c-.57 1.5.18 3.19 1.69 3.76s3.18-.18 3.76-1.69Zm7.26-19.07 3.37 8.93h-6.77z",
    style: {
      fill: "url(#sol_service_sla-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.42 16.52c-1.61 0-2.91 1.3-2.91 2.91v25.18c0 1.42 1.02 2.63 2.42 2.87.21.04.37.06 3.15.06 1.35 0 3.31 0 6.18-.02 1.61 0 2.91-1.32 2.9-2.93 0-1.6-1.31-2.9-2.91-2.9h-.02c-2.04.01-4.23.02-5.9.02V19.42c0-1.61-1.3-2.91-2.91-2.91Z",
    style: {
      fill: "url(#sol_service_sla-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.32 43.19c-2.58.07-5.08-.87-6.71-2.56a2.91 2.91 0 0 0-4.12-.07 2.91 2.91 0 0 0-.07 4.12c2.65 2.74 6.58 4.34 10.59 4.34h.5c5.19-.17 9.44-3.62 10.11-8.2.5-3.44-1.21-7.85-7.51-9.94-3.17-1.05-6.13-2.22-6.99-2.56-.83-.6-.83-1.49-.79-1.85.05-.49.37-1.7 2.1-2.28 3.64-1.23 7.11 1.34 7.21 1.41 1.26.98 3.08.76 4.08-.5.99-1.26.77-3.1-.49-4.09-.24-.19-5.96-4.6-12.65-2.34-3.35 1.13-5.66 3.88-6.02 7.17-.34 3.08 1.09 5.98 3.72 7.58.13.08.27.15.41.21.15.06 3.66 1.49 7.61 2.8 1.17.39 3.87 1.52 3.58 3.58-.22 1.51-1.97 3.13-4.53 3.21Z",
    style: {
      fill: "url(#sol_service_sla-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.62 62.36v12.95c0 2.88 2.34 5.23 5.23 5.23H50.8c2.88 0 5.23-2.34 5.23-5.23V62.36c0-2.88-2.34-5.23-5.23-5.23H37.85c-2.88 0-5.23 2.34-5.23 5.23m5.82.6H50.2v11.76H38.44z",
    style: {
      fill: "url(#sol_service_sla-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.82 62.63c0 1.61 1.3 2.91 2.91 2.91h59.02c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91H68.73c-1.61 0-2.91 1.3-2.91 2.91",
    style: {
      fill: "url(#sol_service_sla-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74 77.51h27.04c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91H68.74c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91",
    style: {
      fill: "url(#sol_service_sla-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.32 95.57c0-2.88-2.34-5.23-5.23-5.23H38.14c-2.88 0-5.23 2.34-5.23 5.23v12.95c0 2.88 2.34 5.23 5.23 5.23h12.95c2.88 0 5.23-2.34 5.23-5.23zm-5.82 12.35H38.74V96.16H50.5z",
    style: {
      fill: "url(#sol_service_sla-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.97 95.83c0-1.61-1.3-2.91-2.91-2.91H69.04c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h59.02c1.61 0 2.91-1.3 2.91-2.91",
    style: {
      fill: "url(#sol_service_sla-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.04 104.89c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h27.04c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91z",
    style: {
      fill: "url(#sol_service_sla-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.32 128.78c0-2.88-2.34-5.23-5.23-5.23H38.14a5.24 5.24 0 0 0-5.23 5.23v12.95c0 2.88 2.34 5.23 5.23 5.23h12.95c2.88 0 5.23-2.34 5.23-5.23zm-5.82 12.35H38.74v-11.76H50.5z",
    style: {
      fill: "url(#sol_service_sla-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.04 143.93h27.04c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91H69.04c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91",
    style: {
      fill: "url(#sol_service_sla-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.09 156.76H38.14c-2.88 0-5.23 2.34-5.23 5.23v12.95c0 2.88 2.34 5.23 5.23 5.23h12.95c2.88 0 5.23-2.34 5.23-5.23v-12.95c0-2.88-2.34-5.23-5.23-5.23m-.59 17.58H38.74v-11.75H50.5z",
    style: {
      fill: "url(#sol_service_sla-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07 177.14c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91H69.03c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91z",
    style: {
      fill: "url(#sol_service_sla-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.95 143.06a2.912 2.912 0 0 0-5.24 2.54c2.25 4.62 3.38 9.58 3.38 14.76 0 18.64-15.17 33.81-33.81 33.81s-33.81-15.17-33.81-33.81 15.17-33.81 33.81-33.81c8.49 0 16.6 3.16 22.85 8.9a2.91 2.91 0 0 0 4.12-.18 2.91 2.91 0 0 0-.18-4.12c-6.61-6.07-15-9.66-23.88-10.31V44.72h20.04c3.33 0 6.04-2.71 6.04-6.04V15.95C176.28 7.16 169.12 0 160.33 0H25.29c-6.73 0-12.21 5.48-12.21 12.21v39.42c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V12.21c0-3.52 2.86-6.39 6.39-6.39h122.72a15.88 15.88 0 0 0-3.64 10.12v104.89a39.3 39.3 0 0 0-17.01 5.28H69.03c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h50.66c-7.19 6.98-11.74 16.66-12.02 27.38H69.02c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h38.92c1.49 12.27 8.59 22.83 18.67 29.01H20.68c-.98 0-1.78-.8-1.78-1.78V65.27c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v127.09c0 4.19 3.41 7.6 7.6 7.6h126.61c21.85 0 39.63-17.78 39.63-39.63 0-6.07-1.34-11.89-3.97-17.31Zm-12.5-127.11v22.74c0 .12-.1.21-.21.21H150.2V15.95c0-5.58 4.54-10.12 10.12-10.12s10.13 4.54 10.13 10.12",
    style: {
      fill: "url(#sol_service_sla-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.16 144.07-15.94 15.94-3.98-3.98c-1.64-1.63-3.83-2.53-6.12-2.5-2.31.02-4.47.95-6.07 2.61-3.21 3.33-3.1 8.76.24 12.1l7.38 7.38c2.15 2.15 4.93 3.43 7.82 3.6.24.01.48.02.71.02 3.15 0 6.19-1.25 8.42-3.48l19.75-19.75a8.46 8.46 0 0 0 2.5-6.12 8.45 8.45 0 0 0-2.62-6.07c-3.33-3.21-8.76-3.1-12.1.24Zm8.1 7.83-19.75 19.75c-1.24 1.24-2.89 1.88-4.66 1.76-1.47-.09-2.91-.76-4.05-1.91l-7.38-7.38c-1.11-1.11-1.19-2.88-.17-3.94.51-.53 1.2-.83 1.93-.83h.03c.73 0 1.41.28 1.92.8l5.43 5.43c1.43 1.43 3.92 1.43 5.34 0l17.39-17.39c1.11-1.11 2.88-1.19 3.94-.17.53.51.83 1.2.83 1.93 0 .74-.28 1.43-.8 1.95",
    style: {
      fill: "url(#sol_service_sla-01_svg2__o)"
    }
  }));
};
export default SvgSolServiceSla01;